import {DetailsList, FontSizes, FontWeights, Icon, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import {useContext, useEffect, useState} from "react";
import * as React from "react";
import EditProjectAddon from "../Panel/ProjectAddon/EditProjectAddon";
import {MoneyField} from "../Utilities/MoneyField";
import {MoneyFormat} from "../Utilities/MoneyFormat";
import { netGrossColumn } from "../Utilities/NetGrossField";

function ProjectAddonList(props) {
    const [user] = useContext(AuthContext);
    const [editAddon, setEditAddon] = useState(false);
    const [sum, setSum] = useState([0,0,0]);
    const [sort, setSort] = useState({key: 'created'});
    const [items, setItems] = useState(props.data);

    useEffect(() => {
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => sort.key === currCol.key)[0];
        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        setColumns(newColumns);
        const sorted = items.slice(0).sort((a, b) => {
            let valueA = a[sort.key];
            let valueB = b[sort.key];
            if (!isNaN(parseFloat(valueA))) {
                valueA = parseFloat(a[sort.key]);
            }
            if (!isNaN(parseFloat(valueB))) {
                valueB = parseFloat(b[sort.key]);
            }
            return ((currColumn?.isSortedDescending ? valueA < valueB : valueA > valueB) ? 1 : -1)
        });
        setItems(sorted);

    }, [sort]);
    const _sort = (e, col) => setSort(col);

    useEffect(() => {
        setItems(props.data);
        setSort(sort);
    }, [props.data])

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        setColumns((prev) => [
            {
                key: 'addon',
                name: 'Dodatek',
                ariaLabel: 'Nazwa Dodatku',
                fieldName: 'addon',
                minWidth: 160,
                isRowHeader: true,
                isResizable: false,
                onColumnClick: _sort,
            },
            {
                key: 'internal',
                name: 'Wewnętrzny',
                ariaLabel: 'Dodatek wewnętrzny',
                fieldName: 'internal',
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                onRender: (item) => ( item.internal ? <Icon iconName={'CheckMark'} title='Tak'/> : '')
            },
            {
                key: 'deadline',
                name: 'Termin',
                ariaLabel: 'Termin Transzy',
                fieldName: 'deadline',
                minWidth: 120,
                isResizable: true,
                onColumnClick: _sort,
                onRender: (item) => ( item.deadline === null ? 'W umowie' : item.deadline)
            },
            {
                minWidth: 120,
                onColumnClick: _sort,
                isSorted: prev[3]?.isSorted,
                isSortedDescending: prev[3]?.isSortedDescending,
                ...netGrossColumn('', 'price', 'Cena ')
            },
            {
                minWidth: 120,
                onColumnClick: _sort,
                isSorted: prev[4]?.isSorted,
                isSortedDescending: prev[4]?.isSortedDescending,
                ...netGrossColumn('base_', 'price', 'Cena Bazowa ')
            },
            {
                key: 'quantity',
                name: 'Ilość',
                ariaLabel: 'Ilość dodatku',
                fieldName: 'quantity',
                minWidth: 120,
                onColumnClick: _sort,
                isResizable: true,
                isSorted: prev[5]?.isSorted,
                isSortedDescending: prev[5]?.isSortedDescending,
            },
            {
                minWidth: 120,
                onColumnClick: _sort,
                isSorted: prev[6]?.isSorted,
                isSortedDescending: prev[6]?.isSortedDescending,
                ...netGrossColumn('', 'total', 'Wartość ')
            },
            {
                key: 'created',
                name: 'Utworzono',
                ariaLabel: 'Utworzono',
                fieldName: 'created',
                minWidth: 120,
                onColumnClick: _sort,
                isResizable: true,
                isSorted: prev[7]?.isSorted ?? true,
                isSortedDescending: prev[7]?.isSortedDescending ?? false
            },
            {
                key: 'delete',
                name: 'Akcje',
                ariaLabel: 'Akcje',
                fieldName: 'delete',
                minWidth: 80,
                isRowHeader: true,
                isResizable: true,
                onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditAddon(item)}/>
                <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
            }
        ]);
    }, [props.netGross]);

    const _delete = (addon) => {
        fetch(`/api/project/${addon.project_id}/addon/${addon.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.refresh(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        let inCost = 0;
        let toPay = 0;
        let internal = 0;

        props.data.forEach((item) => {
            if (item.internal) {
                internal += parseFloat(item.total_price);
            }
            else if (item.deadline !== null) {
                toPay += parseFloat(item.total_price);
            } else {
                inCost += parseFloat(item.total_price);
            }
        });
        setSum([
            MoneyFormat(inCost),
            MoneyFormat(toPay),
            MoneyFormat(internal)
        ]);
    }, [props.data])
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
            <DetailsList items={items} columns={columns} selectionMode={SelectionMode.none}/>
            <h4>Zawarte w umowie: {sum[0]}, Na fakturę: {sum[1]}, Wewnętrzne: {sum[2]}</h4>
            <EditProjectAddon edit={editAddon} dismissPanel={() => setEditAddon(false)} onSuccess={props.refresh}/>
        </Stack.Item>);
    }
    return null;
}

ProjectAddonList.defaultProps = {
    title: 'Dodatki'
}

export default ProjectAddonList;